import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface SelectPartFilters {
  [key: string]: string[];
}

export const selectPartFiltersSlice = createSlice({
  name: "filters",
  initialState: {
    filters: {},
  } as {
    filters: SelectPartFilters;
  },
  reducers: {
    clearFilters: (state) => {
      state.filters = {};
    },
    updateFilters: (state, action: PayloadAction<SelectPartFilters>) => {
      state.filters = action.payload;
    },
  },
});

export const { clearFilters, updateFilters } = selectPartFiltersSlice.actions;

export default selectPartFiltersSlice.reducer;
